import React, { useState, useEffect } from 'react';
import './Flipcclock.style.css';

const getDigits = (t = 0) => {
    const s = t % 60;
    return {
        s1: String(s).padStart(2, '0')[0],
        s2: String(s).padStart(2, '0')[1],
    };
};

const FlipUnit = ({ digit, flip }) => {
    const topDigit    = digit;
    const bottomDigit = flip ? flip.to : digit;

    return (
        <div className="flip">
            <div className="flip-static">
                <div className="up">
                    <div className="inn-wrap">
                        <span className="inn">{topDigit}</span>
                    </div>
                </div>
                <div className="down">
                    <div className="inn-wrap">
                        <span className="inn">{bottomDigit}</span>
                    </div>
                </div>
            </div>

            {flip && (
                <div className="flip-top-anim">
                    <div className="inn-wrap">
                        <span className="inn">{flip.from}</span>
                    </div>
                </div>
            )}

            {flip && (
                <div className="flip-bottom-anim">
                    <div className="inn-wrap">
                        <span className="inn">{flip.to}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

const FlipClock = ({ time }) => {
    const [displayTime, setDisplayTime] = useState(time);
    const [prevDigits, setPrevDigits]   = useState(null);
    const [flipping, setFlipping]       = useState({});

    useEffect(() => {
        const newDigits = getDigits(time);
        if (prevDigits) {
            const flips = {};
            for (const k of ['s1', 's2']) {
                if (prevDigits[k] !== newDigits[k])
                    flips[k] = { from: prevDigits[k], to: newDigits[k] };
            }
            setFlipping(flips);
            setTimeout(() => setFlipping({}), 850);
        }
        setPrevDigits(newDigits);
        setDisplayTime(time);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [time]);

    const currentDigits = getDigits(displayTime);

    return (
        <div className="flip-clock-wrapper">
            <FlipUnit digit={currentDigits.s1} flip={flipping.s1} />
            <FlipUnit digit={currentDigits.s2} flip={flipping.s2} />
        </div>
    );
};

export default FlipClock;